import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { companiesSelect, getCompanies } from 'redux-api/slices/companiesSlice';
import { REQUEST_STATUSES } from 'common/constants';
import { Link } from 'react-router-dom';
import CustomInfoBlock from 'components/UI/CustomInfoBlock/CustomInfoBlock';
import { generateRel, useChangeFromMedia } from 'common/helpers';
import classes from './StudentCompany.module.scss';
import CompanyImage from './CompanyImage';


const StudentCompany = ({ data, title }) => {
  const dispatch = useDispatch();
  const { companies, companiesStatus } = useSelector(companiesSelect);
  const { t } = useTranslation();
  const comps = companies?.results;

  const swiperOpts = useChangeFromMedia(
    { slidesPerView: 7.3, height: 'auto', spaceBetween: 0 },
    { slidesPerView: 3.43, height: 'auto', spaceBetween: 0 },
    { slidesPerView: 5.7, height: 'auto', spaceBetween: 0 },
    { slidesPerView: 3.378, height: 'auto', spaceBetween: 0 },
    { slidesPerView: 6.34, height: 'auto', spaceBetween: 0 },
  );

  useEffect(() => {
    dispatch(getCompanies());

    return () => null;
  }, [ dispatch ]);
  if (companiesStatus !== REQUEST_STATUSES.SUCCEEDED) return null;
  return (
    <Box className={classes.main}>
      <CustomInfoBlock
        text={title || t('WhereDoOurGraduatesWork?')}
        swiperOpts={swiperOpts}
      >
        {(data || comps).map((item, i) => (
          <Box key={i} className={classes.company}>
            <Link to={item?.url} draggable={false} {...generateRel(true)} target='_blank'>
              <CompanyImage
                src={item?.inactive_image}
                hoverSrc={item?.image}
                url={item?.url}
                image_alt={item?.image_alt}
              />
            </Link>
          </Box>
        ))}
      </CustomInfoBlock>
    </Box>
  );
};

export default StudentCompany;
